import Icon from '@platform-ui-common/components/Icon/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color from '@platform-ui-common/utilities/Color.js';

interface ValidationConditionProps {
  label: string;
  valid: boolean;
  testId: string;
}

export default function PasswordValidationCondition({
  label,
  valid,
  testId,
}: ValidationConditionProps): JSX.Element {
  return (
    <div
      className="flex gap-x-2 w-full max-w-field items-center"
      data-testid={`${testId}${valid ? '-valid' : '-invalid'}`}
      aria-live="polite"
    >
      <Icon
        color={Color.Primary}
        type={valid ? 'checkCircle' : 'radioButtonUnchecked'}
        size="LG"
        className="pt-px"
      />
      <Typography tag="span" variant="body">
        {label}
      </Typography>
    </div>
  );
}
